import { Alert } from '@catering/ui';
import type { JSX } from 'react';

export interface SuspensionIndicatorProps {
  reason: string;
  suspendedAt: string;
}

/**
 * `customers/spec.md` → "Indicador de suspensión visible en el detalle".
 * Local to `web-admin`, not `StatusBadge` (`design.md` §7).
 */
export function SuspensionIndicator({
  reason,
  suspendedAt,
}: SuspensionIndicatorProps): JSX.Element {
  const date = new Date(suspendedAt).toLocaleDateString('es-AR');

  return (
    <Alert tone="warning" title="Empresa suspendida">
      <p>Motivo: {reason}</p>
      <p className="mt-1 text-xs">Suspendida el {date}</p>
    </Alert>
  );
}
